import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getConfigPersonalizedInfo } from '@/api/systemStyleConfig'
import type { PersonalizedConfigurationDto } from '@/api/systemStyleConfig'
import { SUCCESS_CODE } from '@/constants'

// 个性化配置：接口数据原样存，各处直接取用
export const usePersonalizedStore = defineStore('personalized', () => {
  const loaded = ref(false)
  const config = ref<PersonalizedConfigurationDto>({})

  const load = async (force = false) => {
    if (loaded.value && !force) return
    const res: any = await getConfigPersonalizedInfo().catch(() => null)
    if (res?.code === SUCCESS_CODE && res.data) {
      config.value = res.data
      loaded.value = true
      applyToBrowser()
    }
  }

  // 同步浏览器标签页：标题=系统名称，图标=登录页标志
  const applyToBrowser = () => {
    if (config.value.systemName) document.title = config.value.systemName
    const icon = config.value.landingPageFlagTempUrl
    if (!icon) return
    let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = icon
  }

  return { loaded, config, load, applyToBrowser }
})
